<script>

    import { toast } from 'bulma-toast'

    import { userStore } from '../stores'
    import PrepaidsService from '../$services/prepaids.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import InfoCard from '../$components/info.card.svelte'

    let loading = false
    let prepaids = []

    getPrepaidsTotal()

    async function getPrepaidsTotal() {

        loading = true
        const resp = await PrepaidsService.getPrepaidsTotal($userStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        prepaids = resp.data
    }

</script>

{#if prepaids.length}
    <InfoCard subtitle="Resumen de prepagos">
        <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
            {#each prepaids as prepaid}
                <div class="column is-half pb-3">
                    <p class="heading has-text-grey mb-1">
                        { prepaid.provider } { prepaid.service } { prepaid.volumetric }KG
                    </p>
                    <p class="is-size-6 has-text-weight-medium">
                        { NumeralMethods.number(prepaid.shipments) } de { NumeralMethods.number(prepaid.guides) }
                        <span class="has-text-grey is-size-7"> = { NumeralMethods.number(prepaid.remaining) } restantes</span>
                    </p>
                </div>
            {/each}
        </div>
    </InfoCard>
{/if}
